export default __webpack_public_path__ + "static/media/sort_table_icon.a80f17b6.svg";